<div class="container-fluid p-0">
  <div class="row mb-4">
    <div class="col-12">
      <h2 class="text-capitalize d-flex align-items-center fw-bold mb-0">
        {{ role?.name }}
      </h2>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-12">
      <div class="card shadow-sm border-0">
        <div class="card-header bg-white border-bottom-0 pt-4">
          <h3 class="h5 fw-bold mb-0">Details</h3>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col">
              <div class="d-flex align-items-start mb-2">
                <i class="bi bi-card-text text-muted me-2"></i>
                <span class="text-dark me-1">{{ 'ROLE.DETAILS.DESCRIPTION' | translate }}:</span>
                <span class="flex-grow-1">{{ role?.description }}</span>
              </div>
            </div>
          </div>
          
          <div class="row border-top mt-3">
            <ul class="list-unstyled mb-0">
              <li class="pt-1 d-flex flex-wrap align-items-center small text-muted">
                <span class="me-4 mb-1 mb-md-0">
                  <i class="bi bi-clock-history me-1"></i>
                  <span class="me-1">{{ 'COMMON.CREATED_AT' | translate }}:</span>
                  <strong [attr.title]="role?.createdAt | date: 'dd MMM yyyy HH:mm'">
                    {{ role?.createdAt | date: 'dd MMM yyyy' }}
                  </strong>
                </span>
                <span class="mb-1 mb-md-0">
                  <i class="bi bi-arrow-clockwise me-1"></i>
                  <span class="me-1">{{ 'COMMON.UPDATED_AT' | translate }}:</span>
                  <strong [attr.title]="role?.updatedAt | date: 'dd MMM yyyy HH:mm'">
                    {{ role?.updatedAt | date: 'dd MMM yyyy' }}
                  </strong>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-lg-8">
      <div class="card shadow-sm border-0">
        <div class="card-header d-flex justify-content-between align-items-center bg-white border-bottom-0 pt-4">
          <h3 class="h5 fw-bold mb-0">
            {{ 'ROLE.DETAILS.ASSOCIATED_PEOPLE' | translate }} <i>{{ role?.name }}</i>
          </h3>
        </div>
        <div class="card-body pt-3">
          @if (role && role.peoples && role.peoples.length > 0) {
            <div class="table-responsive">
              <table class="table table-hover table-striped mb-0">
                <thead>
                  <tr>
                    <th scope="col">{{ 'COMMON.FULL_NAME' | translate }}</th>
                    <th scope="col">{{ 'ROLE.DETAILS.ALLOCATION_RATE' | translate }}</th>
                    <th scope="col">{{ 'COMMON.STATUS' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (person of role.peoples; track person.id) {
                    <tr [ngClass]="getPersonHiringStatusClass(person)">
                      <td scope="row" class="d-flex align-items-center py-2">
                        <app-avatar [personOrPeople]="person" size="normal" shape="circle" class="me-1"></app-avatar>
                        <a [routerLink]="['/peoples', person.id]" class="text-dark text-decoration-none fw-bold">{{ person.firstName }} {{ person.lastName }} </a>
                        @if (getPersonStatusIconAndMessage(person); as statusInfo) {
                        <app-people-status-icon
                            [icon]="statusInfo.icon"
                            [color]="statusInfo.color"
                            [message]="statusInfo.message"
                            [date]="statusInfo.date">
                        </app-people-status-icon>
                        } 
                      </td>
                      <td scope="row" class="py-2">
                        <span class="badge bg-light text-black-50">
                          {{ person.total_allocation_rate }}%
                        </span>
                      </td>
                      <td scope="row" class="py-2">
                        <app-people-status [person]="person"></app-people-status>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <p class="text-muted">{{ 'ROLE.DETAILS.NO_ASSOCIATED_PEOPLE' | translate }}</p>
          }
        </div>
      </div>
    </div>

    <div class="col-lg-4">
      <div class="card shadow-sm border-0">
        <div class="card-header d-flex justify-content-between align-items-center bg-white border-bottom-0 pt-4">
          <h3 class="h5 fw-bold mb-0">{{ 'ROLE.DETAILS.ASSOCIATED_TEAMS' | translate }}</h3>
        </div>
        <div class="card-body pt-3">
          @if (role && role.associatedTeams && role.associatedTeams.length > 0) {
            <ul class="list-unstyled">
              @for (item of role.associatedTeams; track trackByAssociatedTeam($index, item)) {
<li class="list-group-item rounded mb-2 border px-3 py-2 d-flex justify-content-between align-items-center">
                <a [routerLink]="['/teams', item.team.id]" class="text-dark text-decoration-none">{{ item.team.name }}</a>
                @if (item.requiredFte) {
<span class="badge bg-light text-black-50 ms-2">
                  FTE: {{ item.requiredFte }}
                </span>
}
              </li>
}
            </ul>
          } @else {
            <p class="text-muted">{{ 'ROLE.DETAILS.NO_ASSOCIATED_TEAMS' | translate }}</p>
          }
        </div>
      </div>
    </div>
  </div>
  <app-events
    [itemTypeEvents]="'role'"
    [itemId]="roleId">
  </app-events>
</div>